// src/modules/inpatients/data/mockData.js
//
// Mock data layer. In production, replace each exported getter with a real
// API call (see hooks/usePatientRecord.js for the seam where this happens).

export const inPatientsSummary = {
  totalAssigned: 28,
  todaysDischarge: 3,
  todaysRounds: 12,
  criticalPatients: 5,
};

export const inPatientsList = [
  {
    id: "IP-2026-01568",
    uhid: "UHID123456",
    name: "Mr. Balaji P",
    initials: "BP",
    avatarColor: "bg-blue-500",
    age: 34,
    gender: "Male",
    ward: "ICU",
    bed: "A-12",
    diagnosis: "Pneumonia with Respiratory Distress",
    status: "Critical",
    admittedOn: "2026-07-01T10:37:00",
    nurse: "Nurse Priya",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 5,
    listNote: "Patient is stable and under observation",
  },
  {
    id: "IP-2026-01569",
    uhid: "UHID123457",
    name: "Mrs. Kavitha R",
    initials: "SK",
    avatarColor: "bg-emerald-500",
    age: 45,
    gender: "Male",
    ward: "General Ward",
    bed: "B-8",
    diagnosis: "Typhoid Fever",
    status: "Stable",
    admittedOn: "2026-06-30T09:15:00",
    nurse: "Nurse Revathi",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 2,
    listNote: "BP controlled, medication ongoing",
  },
  {
    id: "IP-2026-01570",
    uhid: "UHID123458",
    name: "Mr. Ramesh K",
    initials: "AP",
    avatarColor: "bg-orange-500",
    age: 29,
    gender: "Female",
    ward: "General Ward",
    bed: "B-14",
    diagnosis: "Dengue Fever",
    status: "Stable",
    admittedOn: "2026-06-30T14:45:00",
    nurse: "Nurse Janani",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 2,
    listNote: "Fever reduced, monitoring vitals",
  },
  {
    id: "IP-2026-01571",
    uhid: "UHID123459",
    name: "Mrs. Latha S",
    initials: "RM",
    avatarColor: "bg-purple-500",
    age: 60,
    gender: "Male",
    ward: "Semi Private",
    bed: "C-5",
    diagnosis: "Hypertension",
    status: "Observation",
    admittedOn: "2026-06-29T11:30:00",
    nurse: "Nurse Kavya",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 3,
    listNote: "IV fluids running",
  },
  {
    id: "IP-2026-01572",
    uhid: "UHID123460",
    name: "Mr. Prakash M",
    initials: "RB",
    avatarColor: "bg-slate-500",
    age: 55,
    gender: "Male",
    ward: "Private",
    bed: "D-2",
    diagnosis: "Diabetes Mellitus",
    status: "Stable",
    admittedOn: "2026-06-28T16:20:00",
    nurse: "Nurse Priya",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 4,
    listNote: "Stable, no new complaints",
  },
  {
    id: "IP-2026-01574",
    uhid: "UHID123461",
    name: "Mr. Arun Kumar",
    initials: "AK",
    avatarColor: "bg-cyan-600",
    age: 41,
    gender: "Male",
    ward: "General Ward",
    bed: "B-2",
    diagnosis: "Viral Fever",
    status: "Stable",
    admittedOn: "2026-06-27T09:00:00",
    nurse: "Nurse Kavya",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 5,
    listNote: "Advised rest and hydration",
  },
  {
    id: "IP-2026-01575",
    uhid: "UHID123462",
    name: "Mrs. Divya S",
    initials: "DS",
    avatarColor: "bg-pink-500",
    age: 38,
    gender: "Female",
    ward: "General Ward",
    bed: "B-6",
    diagnosis: "UTI",
    status: "Stable",
    admittedOn: "2026-06-26T12:00:00",
    nurse: "Nurse Revathi",
    attendingDoctor: "Dr. Hari Prakash",
    lengthOfStayDays: 6,
    listNote: "Under antibiotics",
  },
];

export const getPatientById = (id) =>
  inPatientsList.find((p) => p.id === id) || null;



const balajiRecord = {
  vitals: [
    { id: "V-5", date: "2026-07-01", time: "10:15 AM", bp: "120/80", pulse: 78, rr: 18, spo2: 98, temp: 98.6, weight: 72, height: 172, bmi: 24.3, addedBy: "Nurse Priya" },
    { id: "V-4", date: "2026-07-01", time: "06:00 AM", bp: "118/78", pulse: 76, rr: 20, spo2: 97, temp: 98.4, weight: 72, height: 172, bmi: 24.3, addedBy: "Nurse Kavya" },
    { id: "V-3", date: "2026-06-30", time: "10:00 PM", bp: "122/82", pulse: 80, rr: 19, spo2: 97, temp: 99.1, weight: 72, height: 172, bmi: 24.3, addedBy: "Nurse Priya" },
    { id: "V-2", date: "2026-06-30", time: "02:00 PM", bp: "124/84", pulse: 82, rr: 20, spo2: 96, temp: 99.3, weight: 72, height: 172, bmi: 24.3, addedBy: "Nurse Revathi" },
    { id: "V-1", date: "2026-06-30", time: "06:00 AM", bp: "116/76", pulse: 74, rr: 18, spo2: 98, temp: 98.5, weight: 72, height: 172, bmi: 24.3, addedBy: "Nurse Priya" },
  ],
  medications: [
    { id: "M-1", name: "Paracetamol", form: "Tablet", dose: "650 mg", route: "Oral", frequency: "TID", dosage: "1-1-1", takenBy: "After Food", startDate: "2026-07-01", endDate: "2026-07-05", status: "Pending", prescribedBy: "Dr. Hari Prakash" },
    { id: "M-2", name: "Ceftriaxone", form: "Injection", dose: "1 g", route: "IV", frequency: "BD", dosage: "1-0-1", takenBy: "Before Food", startDate: "2026-07-01", endDate: "2026-07-07", status: "Completed", prescribedBy: "Dr. Hari Prakash" },
    { id: "M-3", name: "Pantoprazole", form: "Injection", dose: "40 mg", route: "IV", frequency: "OD", dosage: "1-0-0", takenBy: "Before Food", startDate: "2026-07-01", endDate: "2026-07-06", status: "Completed", prescribedBy: "Dr. Hari Prakash" },
    { id: "M-4", name: "Insulin", form: "Solostar", dose: "8 Units", route: "SC", frequency: "SOS", dosage: "0-1-0", takenBy: "Before Food", startDate: "2026-07-01", endDate: "2026-07-05", status: "Pending", prescribedBy: "Dr. Hari Prakash" },
    { id: "M-5", name: "Ondansetron", form: "Injection", dose: "4 mg", route: "IV", frequency: "TDS", dosage: "1-1-1", takenBy: "After Food", startDate: "2026-06-30", endDate: "2026-07-03", status: "Completed", prescribedBy: "Dr. Hari Prakash" },
  ],
  clinicalNotes: [
    {
      id: "CN-4",
      dateTime: "2026-07-02T10:30:00",
      recordedBy: "Dr. Hari Prakash",
      noteType: "Progress Note",
      noteContent:
        "Fever reduced, patient responding well to treatment.\nVitals stable.\nAdvised to continue IV fluids and antibiotics.\nMonitor vitals 6 hourly.\nPlan: Review tomorrow.",
      attachments: [
        { name: "Lab_Report_02Jul2026.pdf", type: "pdf", size: "245 KB" },
        { name: "Vitals_Chart_02Jul2026.jpg", type: "image", size: "1.2 MB" },
      ],
    },
    {
      id: "CN-3",
      dateTime: "2026-07-01T18:15:00",
      recordedBy: "Dr. Hari Prakash",
      noteType: "Initial Note",
      noteContent: "High grade fever, started on IV antibiotics.",
      attachments: [{ name: "Admission_Note.pdf", type: "pdf", size: "180 KB" }],
    },
    {
      id: "CN-2",
      dateTime: "2026-06-30T11:20:00",
      recordedBy: "Nurse Kavitha R",
      noteType: "Nursing Note",
      noteContent: "Temperature improving, continue treatment.",
      attachments: [{ name: "Followup_30Jun2026.pdf", type: "pdf", size: "140 KB" }],
    },
    {
      id: "CN-1",
      dateTime: "2026-06-28T09:45:00",
      recordedBy: "Dr. Hari Prakash",
      noteType: "Initial Note",
      noteContent: "Patient admitted with fever and weakness.",
      attachments: [{ name: "Admission_Note_28Jun2026.pdf", type: "pdf", size: "160 KB" }],
    },
    {
      id: "CN-0",
      dateTime: "2026-06-27T16:30:00",
      recordedBy: "Dr. Hari Prakash",
      noteType: "Progress Note",
      noteContent: "Condition stable, monitoring vitals.",
      attachments: [{ name: "Progress_27Jun2026.pdf", type: "pdf", size: "150 KB" }],
    },
    {
      id: "CN-00",
      dateTime: "2026-06-26T12:00:00",
      recordedBy: "Nurse Kavitha R",
      noteType: "Nursing Note",
      noteContent: "Patient condition improved, discharge plan initiated.",
      attachments: [{ name: "Nursing_26Jun2026.pdf", type: "pdf", size: "130 KB" }],
    },
    {
      id: "CN-000",
      dateTime: "2026-06-25T10:10:00",
      recordedBy: "Dr. Hari Prakash",
      noteType: "Progress Note",
      noteContent: "IV fluids continued, antibiotics ongoing.",
      attachments: [{ name: "Progress_25Jun2026.pdf", type: "pdf", size: "145 KB" }],
    },
  ],
  doctorNotes: [
    {
      id: "DN-1",
      doctor: "Dr. Hari Prakash",
      role: "Attending Doctor",
      dateTime: "2026-07-01T10:30:00",
      note: "Patient is conscious and oriented. Complains of mild chest discomfort.\nBP and vitals stable. Advised to continue current medication.\nMonitor vitals 6 hourly. Plan: Continue IV fluids and antibiotics. Review tomorrow.",
      nurseFollowUps: [
        { nurse: "Nurse Kavitha R", dateTime: "2026-07-01T08:30:00", note: "Patient vitals recorded. BP: 120/80 mmHg, Pulse: 82 bpm, SpO2: 98% on room air." },
        { nurse: "Nurse Kavitha R", dateTime: "2026-07-01T14:30:00", note: "IV fluids running. Medication administered as per order. No adverse reactions noted." },
      ],
    },
    { id: "DN-2", doctor: "Dr. Hari Prakash", role: "Attending Doctor", dateTime: "2026-06-30T16:15:00", note: "Patient showing improvement. No fever. Appetite normal.\nContinue the same treatment.", nurseFollowUps: [] },
    { id: "DN-3", doctor: "Dr. Hari Prakash", role: "Attending Doctor", dateTime: "2026-06-30T09:00:00", note: "Patient admitted with complaints of weakness and mild fever.\nInitial examination done. Investigations reviewed.\nStarted on IV fluids and antibiotics.", nurseFollowUps: [] },
  ],
  nursingNotes: [
    { id: "NN-1", nurse: "Nurse Kavitha R", role: "Staff Nurse", dateTime: "2026-07-01T14:30:00", note: "Patient vitals recorded. BP: 120/80 mmHg, Pulse: 82 bpm, SpO2: 98% on room air." },
    { id: "NN-2", nurse: "Nurse Kavitha R", role: "Staff Nurse", dateTime: "2026-07-01T08:30:00", note: "Patient given medication as per prescription. No adverse reactions noted." },
    { id: "NN-3", nurse: "Nurse Kavitha R", role: "Staff Nurse", dateTime: "2026-06-30T07:30:00", note: "Assisted patient with morning hygiene and bed bath. Patient comfortable." },
  ],
  medicalHistory: {
    allergies: [
      { id: "AL-1", label: "Drug Allergies: Antibiotics", onset: "2026-02-26" },
      { id: "AL-2", label: "Drug Allergies: Antibiotics", onset: "2026-02-06" },
    ],
    pastMedicalHistory: [
      { id: "PM-1", label: "Mitral Valve Prolapse", onset: "2026-02-26" },
      { id: "PM-2", label: "Myasthenia Gravis", onset: "2026-02-06" },
    ],
    surgicalHistory: [
      { id: "SH-1", label: "Bone Marrow Transplant", onset: "2026-02-26" },
      { id: "SH-2", label: "Testicular Surgery", onset: "2026-02-06" },
    ],
    familyHistory: [],
    socialHistory: [
      { id: "SO-1", label: "Test", onset: "2026-02-26" },
      { id: "SO-2", label: "Normal", onset: "2026-02-06" },
    ],
    medication: [],
    chronicConditions: [{ id: "CC-1", label: "Parkinson's Disease", onset: "2026-05-18" }],
    immunisations: [
      { id: "IM-1", label: "Pneumococcal (PCV13, PPSV23)", onset: "2026-02-26" },
      { id: "IM-2", label: "Influenza (Flu)", onset: "2021-07-22" },
    ],
  },
  orders: [
    { id: "ORD-1001", type: "Medication", icon: "medication", name: "IV Fluids (Normal Saline)", priority: "High", orderedBy: "Dr. Hari Prakash", orderDate: "2026-07-01T10:30:00", status: "Pending" },
    { id: "ORD-1002", type: "Lab Test", icon: "lab", name: "CBC (Complete Blood Count)", priority: "Medium", orderedBy: "Dr. Hari Prakash", orderDate: "2026-07-01T09:15:00", status: "Completed" },
    { id: "ORD-1003", type: "Radiology", icon: "radiology", name: "Chest X-Ray (PA View)", priority: "High", orderedBy: "Dr. Hari Prakash", orderDate: "2026-07-01T09:00:00", status: "Pending" },
    { id: "ORD-1004", type: "Procedure", icon: "procedure", name: "ECG", priority: "Medium", orderedBy: "Dr. Hari Prakash", orderDate: "2026-06-30T18:20:00", status: "Completed" },
    { id: "ORD-1005", type: "Nursing Care", icon: "nursing", name: "Vital Signs Monitoring (6 Hourly)", priority: "High", orderedBy: "Dr. Hari Prakash", orderDate: "2026-06-30T18:00:00", status: "Pending" },
    { id: "ORD-1006", type: "Diet", icon: "diet", name: "Diabetic Diet", priority: "Low", orderedBy: "Dr. Hari Prakash", orderDate: "2026-06-30T17:30:00", status: "Completed" },
    { id: "ORD-1007", type: "Consultation", icon: "consultation", name: "Cardiology Review", priority: "Medium", orderedBy: "Dr. Hari Prakash", orderDate: "2026-06-30T15:45:00", status: "Completed" },
    { id: "ORD-1008", type: "Blood Bank", icon: "bloodbank", name: "Cross Match (2 Units)", priority: "High", orderedBy: "Dr. Hari Prakash", orderDate: "2026-06-30T14:10:00", status: "Pending" },
  ],
  labReports: [
    { id: "LAB-2026-1008", testName: "Complete Blood Count (CBC)", sampleDate: "2026-07-01", reportDate: "2026-07-01", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "LAB-2026-1007", testName: "Liver Function Test (LFT)", sampleDate: "2026-06-30", reportDate: "2026-06-30", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "LAB-2026-1006", testName: "Blood Sugar (Fasting)", sampleDate: "2026-06-30", reportDate: "2026-06-30", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "LAB-2026-1005", testName: "Urine Routine & Microscopy", sampleDate: "2026-06-29", reportDate: "2026-06-29", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "LAB-2026-1004", testName: "Thyroid Profile (T3, T4, TSH)", sampleDate: "2026-06-28", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
    { id: "LAB-2026-1003", testName: "Vitamin B12", sampleDate: "2026-06-28", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
    { id: "LAB-2026-1002", testName: "Lipid Profile", sampleDate: "2026-06-27", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
    { id: "LAB-2026-1001", testName: "Electrolyte Panel", sampleDate: "2026-06-27", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
  ],
  radiology: [
    { id: "RAD-2026-1008", test: "Chest X-Ray (PA View)", bodyPart: "Chest", studyDate: "2026-07-01", reportDate: "2026-07-01", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "RAD-2026-1007", test: "X-Ray Knee (Right)", bodyPart: "Knee", studyDate: "2026-06-30", reportDate: "2026-06-30", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "RAD-2026-1006", test: "USG Abdomen (Whole)", bodyPart: "Abdomen", studyDate: "2026-06-30", reportDate: "2026-06-30", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "RAD-2026-1005", test: "CT Scan Brain (Plain)", bodyPart: "Brain", studyDate: "2026-06-29", reportDate: "2026-06-29", orderedBy: "Dr. Hari Prakash", status: "Completed" },
    { id: "RAD-2026-1004", test: "MRI Spine (Lumbosacral)", bodyPart: "Spine", studyDate: "2026-06-28", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
    { id: "RAD-2026-1003", test: "USG Obstetric (NT Scan)", bodyPart: "Pelvis", studyDate: "2026-06-28", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
    { id: "RAD-2026-1002", test: "X-Ray Shoulder (Left)", bodyPart: "Shoulder", studyDate: "2026-06-27", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
    { id: "RAD-2026-1001", test: "OPG (Orthopantomogram)", bodyPart: "Dental", studyDate: "2026-06-27", reportDate: null, orderedBy: "Dr. Hari Prakash", status: "Pending" },
  ],
  timeline: [
    { id: "T-1", dateTime: "2026-07-01T10:37:00", type: "Admission", title: "Patient Admitted", description: "Patient admitted in ICU - A, Bed - 12", meta: "Chief Complaint: Breathlessness and mild chest discomfort.", by: "Dr. Hari Prakash" },
    { id: "T-2", dateTime: "2026-07-01T10:45:00", type: "Clinical Note", title: "Clinical Note Added", description: "Patient is conscious and oriented. Complains of mild chest discomfort.", meta: "BP and vitals stable. Advised to continue current medication.", by: "Dr. Hari Prakash" },
    { id: "T-3", dateTime: "2026-07-01T11:30:00", type: "Lab Order", title: "Lab Test Ordered", description: "CBC, RBS, Serum Electrolytes", meta: "Ordered Tests: 3", by: "Dr. Hari Prakash" },
    { id: "T-4", dateTime: "2026-07-01T12:15:00", type: "Medication", title: "Medication Ordered", description: "Paracetamol 650mg, Pantoprazole 40mg", meta: "Total Medicines: 2", by: "Dr. Hari Prakash" },
    { id: "T-5", dateTime: "2026-07-01T14:00:00", type: "Radiology", title: "Radiology Ordered", description: "Chest X-Ray (PA View)", meta: "Status: Completed", by: "Dr. Hari Prakash" },
    { id: "T-6", dateTime: "2026-07-01T16:20:00", type: "Nursing Note", title: "Nursing Note Added", description: "Patient vitals recorded. BP: 120/80 mmHg, Pulse: 82 bpm, SpO2: 98% on room air.", meta: "Patient comfortable.", by: "Nurse Kavitha R" },
    { id: "T-7", dateTime: "2026-07-01T18:10:00", type: "Lab Report", title: "Lab Report Available", description: "CBC Report", meta: "Status: Completed", by: "System" },
    { id: "T-8", dateTime: "2026-07-01T20:30:00", type: "Order Status", title: "Order Completed", description: "Chest X-Ray (PA View)", meta: "Status: Completed", by: "System" },
  ],
  discharge: {
    primaryDiagnosis: "Acute Respiratory Infection",
    secondaryDiagnosis: "Hypertension",
    finalDiagnosis: "Acute Respiratory Infection",
    proceduresPerformed: "",
    treatmentGiven: "Antibiotics, Bronchodilators, IV Fluids",
    hospitalCourse:
      "Breathlessness and mild chest discomfort. Treated with antibiotics, bronchodilators and supportive care.\n\nPatient responded well to treatment and is stable at discharge.",
    conditionAtDischarge: "Improved",
    dischargeDateTime: "2026-07-01T20:30:00",
    attendingDoctor: "Dr. Hari Prakash",
    medicationsOnDischarge: [
      { id: "MD-1", medicine: "Paracetamol", dose: "650 mg", frequency: "TID", duration: "5 Days", instructions: "After Food" },
      { id: "MD-2", medicine: "Pantoprazole", dose: "40 mg", frequency: "OD", duration: "5 Days", instructions: "Before Food" },
      { id: "MD-3", medicine: "Levocetirizine", dose: "5 mg", frequency: "OD", duration: "5 Days", instructions: "Night Only" },
    ],
    followUpDate: "2026-07-08",
    followUpDepartment: "General Medicine",
    followUpDoctor: "Dr. Hari Prakash",
    reviewAfterDays: 7,
    patientInstructions: ["Take medicines regularly.", "Drink adequate water.", "Avoid heavy lifting.", "Return immediately if fever or chest pain develops."],
    dietAdvice: "Normal Diet",
    activityAdvice: "Normal Activity",
    investigationsPending: [],
    disposition: "Home",
    clinicalChecklist: {
      diagnosisCompleted: true,
      medicationReviewed: true,
      followUpGiven: true,
      patientInstructionsAdded: true,
      dischargeSummaryCompleted: true,
    },
  },
};

const emptyRecord = {
  vitals: [],
  medications: [],
  clinicalNotes: [],
  doctorNotes: [],
  nursingNotes: [],
  medicalHistory: {
    allergies: [],
    pastMedicalHistory: [],
    surgicalHistory: [],
    familyHistory: [],
    socialHistory: [],
    medication: [],
    chronicConditions: [],
    immunisations: [],
  },
  orders: [],
  labReports: [],
  radiology: [],
  timeline: [],
  discharge: null,
};

const recordsByPatientId = {
  "IP-2026-01568": balajiRecord,
};

export const getPatientRecord = (patientId) =>
  recordsByPatientId[patientId] || emptyRecord;

export const staffOptions = {
  doctors: ["Dr. Hari Prakash", "Dr. Meena Suresh", "Dr. Arjun Nair"],
  nurses: ["Nurse Kavitha R", "Nurse Priya", "Nurse Revathi", "Nurse Kavya", "Nurse Janani"],
  departments: ["ICU", "ER", "General Medicine", "Cardiology", "Orthopedics", "Pediatrics"],
};

// Combined, role-tagged list for "Recorded By" search/select fields where a
// clinical note may be recorded by either a doctor or a nurse.
export const recordedByOptions = [
  ...staffOptions.doctors.map((name) => ({ name, role: "Doctor" })),
  ...staffOptions.nurses.map((name) => ({ name, role: "Nurse" })),
];

export const NOTE_TYPES = ["Initial Note", "Progress Note", "Follow-up Note", "Nursing Note", "Discharge Note"];
